var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1967 18.5129H1.80411C1.57606 18.5137 1.3504 18.4675 1.14197 18.3771C0.933546 18.2867 0.747066 18.1543 0.594789 17.9885C0.263195 17.6547 0.0803804 17.2063 0.0862901 16.7413V2.45166C0.0803804 1.98666 0.263195 1.53827 0.594789 1.20448C0.747066 1.0387 0.933546 0.906276 1.14197 0.815896C1.3504 0.725515 1.57606 0.67923 1.80411 0.68008H21.1967C21.4247 0.67923 21.6504 0.725515 21.8588 0.815896C22.0673 0.906276 22.2537 1.0387 22.406 1.20448C22.7376 1.53827 22.9204 1.98666 22.9145 2.45166V16.7413C22.9204 17.2063 22.7376 17.6547 22.406 17.9885C22.2537 18.1543 22.0673 18.2867 21.8588 18.3771C21.6504 18.4675 21.4247 18.5137 21.1967 18.5129ZM8.29874 11.0705L2.79942 16.7413H20.2014L14.7032 11.0705L11.5004 13.3035L8.2976 11.0705H8.29874ZM21.1967 6.42559L15.8726 10.2218L21.1967 15.7143V6.42559ZM1.80411 6.51587V15.7143L7.12822 10.2652L1.80411 6.51587ZM1.80411 2.45166V4.77383L11.5004 11.6055L21.1539 4.72924L21.1973 4.77383V2.45166H1.80411Z",
    fill: "#4F5251",
    stroke: "#4F5251",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 18,
    fill: "white",
    transform: "translate(0 0.596436)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.fa36b9738df4525f8e35d9cd3df65e8d.svg";
export { ForwardRef as ReactComponent };